import React, { useMemo, useRef } from 'react';
import { observer } from 'mobx-react-lite';

import { isMobile } from '../../../../../core/helpers/isMobile';

import { freeBetStore } from '../../../../../store/freeBetStore';
import { applicationStore } from '../../../../../store/applicationStore';

import TextOrderingByWidth from '../../../textOrderingByWidth';

const FreeBetAwardCount = observer(() => {
  const freeBetAwardCountRef = useRef(null);
  const {
    currentFreeBet: { remainingCount },
  } = freeBetStore;
  const {
    canvasTranslationKeys: { FREE_SPINS_BONUS_1, FREE_SPINS_BONUS_2 },
  } = applicationStore;

  const texts = useMemo(() => {
    return [
      {
        id: 0,
        text: FREE_SPINS_BONUS_1,
        style: { fill: '#FFC33E', _fontWeight: 700, _fontSize: isMobile() ? 20 : 24 },
        ref: null,
      },
      {
        id: 1,
        text: `${remainingCount}`,
        style: { fill: '#FFFFFF', _fontWeight: 700, _fontSize: isMobile() ? 24 : 30 },
        ref: freeBetAwardCountRef,
      },
      {
        id: 2,
        text: FREE_SPINS_BONUS_2,
        style: { fill: '#FFFFFF', _fontWeight: 700, _fontSize: isMobile() ? 20 : 24 },
        ref: null,
      },
    ];
  }, [remainingCount, FREE_SPINS_BONUS_1, FREE_SPINS_BONUS_2]);

  return <TextOrderingByWidth texts={texts} />;
});

export default FreeBetAwardCount;
